import { render, staticRenderFns } from "./room-rent-tab.vue?vue&type=template&id=1a9d793d"
import script from "./room-rent-tab.vue?vue&type=script&lang=js"
export * from "./room-rent-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports